import React from 'react';
import PropertyImageManager from '../components/PropertyImageManager';

const ImagesView = () => {
  return (
    <div className="space-y-8">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-gray-900">Property Images</h1>
      </div>

      <PropertyImageManager />
    </div>
  );
};

export default ImagesView;